import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';

const getFeedRoutes = (type, params = {}) => {
  switch (type) {
    case MY_GROUPS_FEED_TYPE: {
      const {
        currentUser: { id: currentUserId },
      } = params;

      return {
        feed_items_path: (routeParams) =>
          Routes.topics_topics_v2_feed_items_path({
            ...routeParams,
            followed_by_user: true,
          }),
        like_path: (likeableType, likeId) =>
          Routes.user_like_path(likeableType, likeId),
        likes_path: () => Routes.user_likes_path(currentUserId),
        post_path: (postId, topicId) =>
          Routes.topics_topic_post_path(topicId, postId),
      };
    }
    case GROUP_FEED_TYPE: {
      const {
        currentUser: { id: currentUserId },
        topic: { id: topicId },
      } = params;

      return {
        feed_items_path: (routeParams) =>
          Routes.topics_topic_feed_items_path(topicId, routeParams),
        like_path: (likeableType, likeId) =>
          Routes.user_like_path(likeableType, likeId),
        likes_path: () => Routes.user_likes_path(currentUserId),
        post_path: (postId) => Routes.topics_topic_post_path(topicId, postId),
      };
    }
    default:
    case NETWORK_FEED_TYPE: {
      const {
        currentUser: { id: currentUserId },
      } = params;

      return {
        business_opportunities_request_path: (postId) =>
          Routes.user_business_opportunities_request_path(
            currentUserId,
            postId,
          ),
        event_path: (postId) => Routes.user_event_path(currentUserId, postId),
        feed_items_path: (routeParams) => Routes.feed_items_path(routeParams),
        top_posts_feed_items_path: (routeParams) =>
          Routes.top_posts_feed_items_path(routeParams),
        like_path: (likeableType, likeId) =>
          Routes.user_like_path(likeableType, likeId),
        likes_path: () => Routes.user_likes_path(currentUserId),
        checkin_path: (postId) =>
          Routes.user_location_path(currentUserId, postId),
        post_path: (postId) => Routes.user_post_path(currentUserId, postId),
        trip_path: (postId) => Routes.user_trip_path(currentUserId, postId),
        ventures_venture_path: (postId) =>
          Routes.user_ventures_venture_path(currentUserId, postId),
      };
    }
  }
};

export default getFeedRoutes;
